import {axiosInstance} from "../instance";

const UserList = () => {
    return axiosInstance.get('/api/user');
};

const UserAdminList = () => {
    return axiosInstance.get('/api/users-admin');
};

const AddUser = (user) => {
    return axiosInstance.post('/api/addUser', user);
};

const GetUser = (id) => {
    return axiosInstance.get('/api/user/' + id);
};

const EditUser = (user) => {
    return axiosInstance.post('/api/editUser', user);
};

const GetLoggedUser = () => {
    return axiosInstance.get('/api/user-logged');
};

const GetUsersEmulsionReports = (id, from, to) => {
    if (!!from && !!to) {
        return axiosInstance.get(`/api/user-reports/${id}/${from}/${to}`);
    } else if (!!from) {
        return axiosInstance.get(`/api/user-reports/${id}/${from}`);
    }
    return axiosInstance.get(`/api/user-reports/${id}`);
}

const GetUserMenuCategories = (id) => {
    return axiosInstance.get(`/api/user/${id}/menu-categories`);
};

export {
    UserList,
    UserAdminList,
    AddUser,
    EditUser,
    GetUser,
    GetLoggedUser,
    GetUsersEmulsionReports,
    GetUserMenuCategories,
};
